import * as React from 'react';
import { useLocation } from 'react-router-dom';
import qs from 'qs';
import { getCountryFromTimezone } from 'src/utils/timezoneToCountry';
import { createInitialPrefix } from 'src/pages/Login/forms/SignupForm';

export function useQuery() {
  const query = useLocation().search;
  return qs.parse(query, { ignoreQueryPrefix: true });
}

export const useInitialPrefix = () => {
  const [initialPrefix, setInitialPrefix] = React.useState<string>('');

  React.useEffect(() => setInitialPrefix(getCountryFromTimezone() || createInitialPrefix()?.iso2 || 'us'));
  return initialPrefix;
};

type HashItem = {
  access_token: string;
  settings_initial_tab: 'myPlan' | 'upgrade' | 'billing' | 'myProfile';
};

function getHash(): Partial<Record<keyof HashItem, string>> {
  const { hash } = window.location;

  const hashWithoutSharp = hash.startsWith('#') ? hash.substring(1) : hash;
  const params = new URLSearchParams(hashWithoutSharp);
  const result: Partial<Record<keyof HashItem, string>> = {};
  params.forEach((value, key) => {
    result[key as keyof HashItem] = value;
  });
  return result;
}

export function getHashParam<P extends keyof HashItem>(paramName: P): HashItem[P] | undefined {
  const hashObj = getHash();
  const value = hashObj[paramName];
  if (value === undefined) {
    return undefined;
  }

  if (paramName === 'settings_initial_tab') {
    if (value === 'myPlan' || value === 'upgrade' || value === 'billing' || value === 'myProfile') {
      return value as HashItem[P];
    }
    return undefined;
  }

  if (paramName === 'access_token') {
    return value as HashItem[P];
  }

  return undefined;
}
